module.exports = __webpack_public_path__ + "static/media/hospital.60e3069c.svg";